export default "__VITE_ASSET__DTUGsUpO__"